import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGFormSender} from "vgformsender";
import {VGSelect} from "vgselect";
import {VGMap, VGMap3} from "../../../../modules/index.esm";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.Scroll.ToTop.init($(window));
		VG.Scroll.categories($(window));
		VG.Scroll.LoadMap.yaMap('#yaMap');
		VG.Scroll.Header.init($(window));

		// [vegas]
		VG.log();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.Scroll.ToTop.setPosition($self);
		VG.Scroll.categories($self);
		VG.Scroll.Header.init($self);
		VG.Scroll.LoadMap.yaMap('#yaMap');
	},

	onResize: ($self) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');

			$self.find('a[href=""][data-fancybox] img').each(function(){
				$(this).closest('a').attr('href', $(this).attr('src'));
			});

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}
		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableVGSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableFormSender();
			VG.plugins.enableFormSendLoadings();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: false,
				enableHamburger: false
			});
		},

		enableAOS: function ()  {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableVGSelect: function ()  {
			let elements = document.querySelectorAll('.vg-select:has(option)');
			for (const element of elements) {
				new VGSelect(element, {})
			}
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableFormSender: function () {
			const $forms = document.querySelectorAll('[data-vgformsender]');
			if ($forms.length) {
				$forms.forEach(function (form) {
					new VGFormSender(form).submit();
				});
			}
		},

		enableFormSendLoadings: function () {
			$('form').submit(function () {
				let $btn = $(this).find('button[type=submit]');
				let textLoading = $btn.data('loading-text');
				if (textLoading) {
					$btn.text(textLoading).attr('disabled', 'disabled');
				}
			});
		},
	},

	Scroll: {
		categories: function ($window) {
			let $categories = document.getElementById('catalog-categories');
			if ($categories) {
				let top = $categories.offsetHeight,
					scroll = $window.scrollTop(),
					height = 190;

				if (window.innerWidth < 768) {
					height = 120;
				}

				if ((top + height) < scroll) {
					$categories.classList.add('fixed');
				} else {
					$categories.classList.remove('fixed')
				}
			}
		},

		Header: {
			lastScrollTop: 0,
			body: $('body'),

			init: function ($window) {
				let $sticky = $('.header-wrapper'),
					scroll = $window.scrollTop();

				if (scroll > 0) {
					this.body.addClass('header--is-scroll');
					$sticky.addClass('scroll');

					if (scroll > this.lastScrollTop) {
						$sticky.removeClass('fixed');
						this.body.removeClass('header--is-fixed');
					} else {
						$sticky.addClass('fixed');
						this.body.addClass('header--is-fixed');
					}

					this.lastScrollTop = scroll;
				} else if (scroll === 0) {
					$sticky.removeClass('scroll').removeClass('fixed');
					this.body.removeClass('header--is-scroll header--is-fixed');
				}
			},
		},

		ToTop: {
			posActive: 400,
			btn: 'btn-scroll-to-top',

			init: function ($window) {
				let $layoutScrollToTop = $('#' + this.btn);

				if (!$layoutScrollToTop.length) {
					$('body').append('<div class="to-top" id="'+ this.btn +'"><span><i class="fal fa-chevron-up"></i></span></div>')

					this.setPosition($window);
				}

				let $btnScrollToTop = $('#' + this.btn + ' span');
				$btnScrollToTop.click(function () {
					window.scrollTo(0, 0);

					return false;
				});
			},

			setPosition: function ($window) {
				let $sticky = $('#' + this.btn ),
					scroll = $window.scrollTop();

				if (scroll >= this.posActive) {
					$sticky.addClass('is-active');
				} else {
					$sticky.removeClass('is-active');
				}
			}
		},

		LoadMap: {
			isInit: false,
			yaMap: function (map) {
				let $map = document.querySelector(map);

				if ($map) {
					let offsetTop = $map.getBoundingClientRect().top,
						windowHeight = window.innerHeight,
						offset = offsetTop - windowHeight;

					if (offset < 100 && !this.isInit) {
						if (App.yaMapVersion === 'v3') {
							VGMap3.init($map);
						} else if (App.yaMapVersion === '2.1') {
							VGMap.init($map);
						}
						this.isInit = true;
					}
				}
			}
		}
	},
}


export default VGListener;
